import platformImg from "../assets/platform.png";
import hillsImg from "../assets/hills.png";
import backgroundImg from "../assets/background.png";
import platformSmallTallImg from "../assets/platformSmallTall.png";

//Character Sprites
import spriteRunLeft from "../assets/spriteRunLeft.png";
import spriteRunRight from "../assets/spriteRunRight.png";
import spriteStandLeft from "../assets/spriteStandLeft.png";
import spriteStandRight from "../assets/spriteStandRight.png";

//My Assets
import introBoard from "../assets/introboard.png";
import thaparBoard from "../assets/thaparBoard.png";
import newWorkExp from "../assets/workExp.png";
import achvBoard from "../assets/achvBoard.png";
import ufoFinal from "../assets/ufoFinal.png";
import connectBoard from "../assets/connectBoard.png";
import audioLogo from "../assets/audioLogo.png";
import noAudioLogo from "../assets/noAudioLogo.jpg";
import wKey from "../assets/wButton.png";
import aKey from "../assets/aButton.png";
import dKey from "../assets/dButton.png";

//Setting initial audio logo
// document.querySelector(".audioImg").src = noAudioLogo;
// let imageRef = document.querySelector(".audioImg");
// let img = false;
// let audio = document.querySelector(".myAudio");

// imageRef.addEventListener("click", () => {
//   // console.log('CLICKED');
//   if (img == true) {
//     document.querySelector(".audioImg").src = noAudioLogo;
//     // console.log('noaudio');
//     img = false;
//     audio.pause();
//   } else {
//     document.querySelector(".audioImg").src = audioLogo;
//     // console.log('audio');
//     img = true;
//     console.log(audio);
//     audio.play();
//   }
// });

//Setting up keyboard images
document.querySelector(".wKey").src = wKey;
document.querySelector(".aKey").src = aKey;
document.querySelector(".dKey").src = dKey;

let wKeyPressed = false;
document.addEventListener("keydown", function (event) {
  if ((event.key == "W" || event.key == "w") && !wKeyPressed) {
    wKeyPressed = true;
    const img = document.querySelector(".wKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop + 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

document.addEventListener("keyup", function (event) {
  if (event.key == "W" || event.key == "w") {
    wKeyPressed = false;
    const img = document.querySelector(".wKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop - 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

let aKeyPressed = false;
document.addEventListener("keydown", function (event) {
  if ((event.key == "A" || event.key == "a") && !aKeyPressed) {
    aKeyPressed = true;
    const img = document.querySelector(".aKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop + 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

document.addEventListener("keyup", function (event) {
  if (event.key == "A" || event.key == "a") {
    aKeyPressed = false;
    const img = document.querySelector(".aKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop - 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

let dKeyPressed = false;
document.addEventListener("keydown", function (event) {
  if ((event.key == "D" || event.key == "d") && !dKeyPressed) {
    dKeyPressed = true;
    const img = document.querySelector(".dKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop + 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

document.addEventListener("keyup", function (event) {
  if (event.key == "D" || event.key == "d") {
    dKeyPressed = false;
    const img = document.querySelector(".dKey");
    let currentTop = parseInt(window.getComputedStyle(img).top, 10);
    // console.log("Current top:", currentTop);
    img.style.top = currentTop - 10 + "px";
    // console.log("New top:", img.style.top);
  }
});

//CANVAS CODE STARTS HERE :

const canvas = document.querySelector("canvas");
const ctx = canvas.getContext("2d");

// console.log(platformImg);

//Canvas Size
canvas.width = window.innerWidth;
// canvas.height = window.innerHeight;
// canvas.width = 1024;
canvas.height = 576;

const gravity = 0.5;
class Player {
  constructor() {
    this.speed = 7;
    this.position = {
      x: 100,
      y: 100,
    };

    this.width = 66;
    this.height = 150;

    this.velocity = {
      x: 0,
      y: 1,
    };

    this.image = createImage(spriteStandRight);
    this.frames = 0;
    this.sprites = {
      stand: {
        right: createImage(spriteStandRight),
        left: createImage(spriteStandLeft),

        cropWidth: 177,
        width: 66,
      },
      run: {
        right: createImage(spriteRunRight),
        left: createImage(spriteRunLeft),

        cropWidth: 341,
        width: 127.875,
      },
    };

    this.currentSprite = this.sprites.stand.right;
    this.currentCropWidth = 177;
  }

  //Methods or Functions
  draw() {
    // ctx.fillStyle = 'red';
    // ctx.fillRect(this.position.x,this.position.y,this.width,this.height);
    ctx.drawImage(
      this.currentSprite,
      this.currentCropWidth * this.frames,
      0,
      this.currentCropWidth,
      400,
      this.position.x,
      this.position.y,
      this.width,
      this.height
    );
  }

  update() {
    this.frames++;
    // if(this.frames>28) this.frames = 0;
    if (
      this.frames > 59 &&
      (this.currentSprite === this.sprites.stand.right ||
        this.currentSprite === this.sprites.stand.left)
    ) {
      this.frames = 0;
    } else if (
      this.frames > 29 &&
      (this.currentSprite === this.sprites.run.right ||
        this.currentSprite === this.sprites.run.left)
    ) {
      this.frames = 0;
    }

    this.position.y += this.velocity.y;
    this.position.x += this.velocity.x;
    this.draw();

    if (this.position.y + this.height + this.velocity.y <= canvas.height) {
      this.velocity.y += gravity;
    } else {
      // this.velocity.y = 0;
    }
  }
}

class Platform {
  constructor({ x, y, image }) {
    this.position = {
      x: x,
      y: y,
    };

    this.image = image;
    this.width = image.width;
    this.height = image.height;
  }

  draw() {
    // ctx.fillStyle = 'blue';
    // ctx.fillRect(this.position.x,this.position.y,this.width,this.height);
    ctx.drawImage(this.image, this.position.x, this.position.y);
  }
}

class GenericObject {
  constructor({ x, y, image }) {
    this.position = {
      x: x,
      y: y,
    };

    this.image = image;
    this.width = image.width;
    this.height = image.height;
  }

  draw() {
    // ctx.fillStyle = 'blue';
    // ctx.fillRect(this.position.x,this.position.y,this.width,this.height);
    ctx.drawImage(this.image, this.position.x, this.position.y);
  }
}

// const image = new Image();
// image.src = platformImg;
function createImage(imageSrc) {
  const image = new Image();
  image.src = imageSrc;
  return image;
}

let player = new Player();
// const platform = new Platform();
let platformCreatedImg = createImage(platformImg);
let platformSmallTallCreatedImg = createImage(platformSmallTallImg);
let IntroBoardCreatedImg = createImage(introBoard);
let thaparBoardImg = createImage(thaparBoard);
let workExpImg = createImage(newWorkExp);
let achvBoardImg = createImage(achvBoard);
let ufoFinalImg = createImage(ufoFinal);
let connectBoardImg = createImage(connectBoard);

let platforms = [];
let genericObjects = [];

let lastKey;
const keys = {
  right: {
    pressed: false,
  },
  left: {
    pressed: false,
  },
};

let scrollOffset = 0;

function Init() {
  player = new Player();
  // const platform = new Platform();
  platformCreatedImg = createImage(platformImg);
  platformSmallTallCreatedImg = createImage(platformSmallTallImg);
  IntroBoardCreatedImg = createImage(introBoard);
  thaparBoardImg = createImage(thaparBoard);
  workExpImg = createImage(newWorkExp);
  achvBoardImg = createImage(achvBoard);
  ufoFinalImg = createImage(ufoFinal);
  connectBoardImg = createImage(connectBoard);

  platforms = [
    new Platform({
      x:
        platformCreatedImg.width * 4 +
        300 -
        2 +
        platformCreatedImg.width -
        platformSmallTallCreatedImg.width,
      y: 270,
      image: platformSmallTallCreatedImg,
    }),
    new Platform({
      x:
        platformCreatedImg.width * 11 +
        99 +
        platformCreatedImg.width -
        platformSmallTallCreatedImg.width,
      y: 270,
      image: platformSmallTallCreatedImg,
    }),
    //Into Board Image
    new Platform({
      x: platformCreatedImg.width - 50,
      y: 160,
      image: IntroBoardCreatedImg,
    }),
    //Thapar Student Image
    new Platform({
      x: platformCreatedImg.width * 3 + 300,
      y: 170,
      image: thaparBoardImg,
    }),
    //Work Exp Image
    new Platform({
      x: platformCreatedImg.width * 7 - 250,
      y: 125,
      image: workExpImg,
    }),
    //Achievements And Certification Image
    new Platform({
      x: platformCreatedImg.width * 7 + 1022,
      y: 50,
      image: achvBoardImg,
    }),
    //UFO TECH STACK
    new Platform({
      x: platformCreatedImg.width * 12 + 800,
      y: 11,
      image: ufoFinalImg,
    }),
    //Connect Board Img
    new Platform({
      x: platformCreatedImg.width * 14 + 770,
      y: 120,
      image: connectBoardImg,
    }),
    //Platforms
    new Platform({ x: -1, y: 470, image: platformCreatedImg }),
    new Platform({
      x: platformCreatedImg.width - 3,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 2 + 100,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 3 + 300,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 4 + 300 - 2,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 5 + 700 - 2,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 6 + 700 - 3,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 7 + 1000,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 10 + 100,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 11 + 99,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 12 + 500,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 13 + 500 - 2,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 14 + 700 - 2,
      y: 470,
      image: platformCreatedImg,
    }),
    new Platform({
      x: platformCreatedImg.width * 15 + 260 - 3,
      y: 470,
      image: platformCreatedImg,
    }),
  ];

  genericObjects = [
    new GenericObject({ x: -1, y: -1, image: createImage(backgroundImg) }),
    new GenericObject({ x: -1, y: -1, image: createImage(hillsImg) }),
  ];

  scrollOffset = 0;
}

function animate() {
  requestAnimationFrame(animate);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  genericObjects.forEach((genericObject) => {
    genericObject.draw();
  });

  // platform.draw();
  platforms.forEach((platform) => {
    platform.draw();
  });
  player.update();

  platforms.forEach((platform) => {
    if (keys.right.pressed && player.position.x < 400) {
      player.velocity.x = player.speed;
    } else if (
      (keys.left.pressed && player.position.x > 100) ||
      (keys.left.pressed && scrollOffset === 0 && player.position.x > 0)
    ) {
      player.velocity.x = -player.speed;
    } else {
      player.velocity.x = 0;
    }

    if (
      player.position.y + player.height <= platform.position.y &&
      player.position.y + player.height + player.velocity.y >=
        platform.position.y &&
      player.position.x + player.width >= platform.position.x &&
      player.position.x <= platform.position.x + platform.width
    ) {
      player.velocity.y = 0;
    }
  });

  if (keys.right.pressed) {
    scrollOffset += player.speed;
    // platform.position.x -= 5;
    platforms.forEach((platform) => {
      platform.position.x -= player.speed;
    });

    genericObjects.forEach((genericObject) => {
      genericObject.position.x -= player.speed * 0.6;
    });
  } else if (keys.left.pressed && scrollOffset > 0) {
    scrollOffset -= player.speed;
    // platform.position.x += 5;
    platforms.forEach((platform) => {
      platform.position.x += player.speed;
    });

    genericObjects.forEach((genericObject) => {
      genericObject.position.x += player.speed * 0.6;
    });
  }

  //Sprite Switching Lagging Fix
  if (
    keys.right.pressed &&
    lastKey === "right" &&
    player.currentSprite !== player.sprites.run.right
  ) {
    player.frames = 1;
    player.currentSprite = player.sprites.run.right;
    player.currentCropWidth = player.sprites.run.cropWidth;
    player.width = player.sprites.run.width;
  } else if (
    keys.left.pressed &&
    lastKey === "left" &&
    player.currentSprite !== player.sprites.run.left
  ) {
    player.currentSprite = player.sprites.run.left;
    player.currentCropWidth = player.sprites.run.cropWidth;
    player.width = player.sprites.run.width;
  } else if (
    !keys.left.pressed &&
    lastKey === "left" &&
    player.currentSprite !== player.sprites.stand.left
  ) {
    player.currentSprite = player.sprites.stand.left;
    player.currentCropWidth = player.sprites.stand.cropWidth;
    player.width = player.sprites.stand.width;
  } else if (
    !keys.right.pressed &&
    lastKey === "right" &&
    player.currentSprite !== player.sprites.stand.right
  ) {
    player.currentSprite = player.sprites.stand.right;
    player.currentCropWidth = player.sprites.stand.cropWidth;
    player.width = player.sprites.stand.width;
  }

  // console.log(scrollOffset);

  //WIN CONDITION
  if (scrollOffset > platformCreatedImg.width * 15 - 2) {
    // console.log('You win');
    player.speed = 0;
  }

  if (lastKey == "left" && player.speed == 0) {
    player.speed = 7;
  }

  //LOSE CONDITION
  if (player.position.y > canvas.height) {
    // console.log('You loose');
    Init(); //reset all the game drawing
  }
}

window.onload = () => {
  animate();
  Init();
};

addEventListener("keydown", ({ keyCode }) => {
  // console.log(keyCode);
  switch (keyCode) {
    case 65:
      // console.log('left');
      keys.left.pressed = true;
      lastKey = "left";
      break;

    case 83:
      // console.log('down');
      break;

    case 68:
      // console.log('right');
      keys.right.pressed = true;
      lastKey = "right";
      break;

    case 87:
      // console.log('up');
      player.velocity.y -= 15;
      break;
  }
});

addEventListener("keyup", ({ keyCode }) => {
  // console.log(keyCode);
  switch (keyCode) {
    case 65:
      // console.log('left');
      keys.left.pressed = false;
      player.currentSprite = player.sprites.stand.left;
      player.currentCropWidth = player.sprites.stand.cropWidth;
      player.width = player.sprites.stand.width;
      break;

    case 83:
      // console.log('down');
      break;

    case 68:
      // console.log('right');
      keys.right.pressed = false;
      break;

    case 87:
      // console.log('up');
      // player.velocity.y -= 20;
      break;
  }
});
